/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Audit
 * Centralised audit log for TheCargo platform. Each service publishes audit events to RabbitMQ after committing its own write transaction; this service consumes those events and stores them in MongoDB for cross-service search.

**Authentication.** Platform superuser JWT — `Authorization: Bearer <token>`, obtain via `POST /auth/api/v1/auth/login`. Service-to-service callers use the internal API at `/api/internal/audit/*` with the `X-Service-Secret` header.

**Data retention.** Events older than **365 days** are deleted automatically by Mongo's TTL index.

**Contact.** For API access or issues contact **support@thecargo.io**.
 * OpenAPI spec version: 1.0.0
 */

export type AuditAction = (typeof AuditAction)[keyof typeof AuditAction]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuditAction = {
  create: 'create',
  update: 'update',
  delete: 'delete',
} as const
